import { render, staticRenderFns } from "./BidsList.vue?vue&type=template&id=841d6d2c&scoped=true"
import script from "./BidsList.vue?vue&type=script&lang=js"
export * from "./BidsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841d6d2c",
  null
  
)

export default component.exports